import { CalendarCheck } from '@phosphor-icons/react';

export default CalendarCheck;